module.exports = {
    I: "I",
    D: "D",
    U: "U",
    R: "R",
    N: "N"
};
